/**
 * UploadContext — Provides a file upload callback to components
 * deep in the ReactFlow tree (e.g., ReferenceSelector).
 *
 * The upload function creates an upload node on the canvas and
 * returns the new node's ID. Unlike the director chat upload,
 * it does NOT pan the canvas to the new node.
 */

import { createContext, useContext } from 'react'

/**
 * Upload a file to the canvas, creating the corresponding upload node.
 * Returns the new node's ID.
 */
export type UploadFileFn = (file: File, type: 'image' | 'video' | 'audio') => string

const UploadContext = createContext<UploadFileFn | null>(null)

export function useUploadFile(): UploadFileFn | null {
  return useContext(UploadContext)
}

export { UploadContext }
